var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowBars)?_c('Doughnut',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"chart-id":'doughnut-chart',"dataset-id-key":'label',"plugins":[],"css-classes":'',"styles":{},"width":400,"height":400}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }